<!--
  综合活动 - 确认名单
-->
<template>
  <div class="SubWebPage" v-loading.fullscreen.lock="fullscreenLoading">
    <search
      :SearchTitles="SearchTitles"
      :ColNumber="3"
      :SearchList="SearchList"
      ref="SearchList"
      @onSearch="onSearch"
      v-if="SearchList != null"
    ></search>
    <!-- 列表-->
    <el-card class="box-card">
      <div slot="header" class="card-header">
        <h3 class="card-title titleCont">
          <span class="spIcon"></span>
          {{ Title }}
        </h3>
        <div class="card-tools">
          <comImport
            v-if="ImportFile != null && ImportUrl != null"
            @onImportSuccess="onImportSuccess"
            :title="ImportTitle"
            :template="ImportFile"
            :path="ImportUrl"
            ref="conImportFile"
            :btnSize="'small'"
            :btnName="'导入名单'"
          >
          </comImport>
        </div>
      </div>
      <div class="card-body p-0" v-if="itemData != null && itemData.length > 0">
        <div class="text item">
          <el-table :data="itemData" v-if="false">
            <el-table-column
              align="center"
              type="index"
              width="100px;"
              label="序号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="className"
              label="班级"
              min-width="120"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="studentNo"
              label="学号"
              min-width="120"
            >
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.studentNo == null || scope.row.studentNo == ''
                  "
                  >/</span
                >
                <span v-else>{{ scope.row.studentNo }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="学生" width="120">
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.studentName == null || scope.row.studentName == ''
                  "
                  >/</span
                >
                <span v-else>{{ scope.row.studentName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="left"
              label="上传（点击图片浏览）"
              min-width="400"
            >
              <template slot-scope="scope">
                <el-image
                  v-for="(item, index) in scope.row.uploadFild"
                  fit="contain"
                  :key="index"
                  style="width: 50px; height: 50px; marginleft: 10px"
                  :src="item"
                  :preview-src-list="scope.row.uploadFild"
                >
                </el-image>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="status"
              label="审核状态"
              min-width="200px"
              fixed="right"
            >
              <template slot-scope="scope">
                <div>
                  <operationBtn
                    @click.native="handleAuditStatus(scope.row, true)"
                    btnType="success"
                    :btnName="'通过'"
                  >
                  </operationBtn>
                  <operationBtn
                    @click.native="handleAuditStatus(scope.row, false)"
                    btnType="danger"
                    :btnName="'不通过'"
                  >
                  </operationBtn>
                </div>
                <el-radio-group v-model="scope.row.isAudit" v-if="false">
                  <el-radio :label="true" :disabled="scope.row.scoring"
                    >通过</el-radio
                  >
                  <el-radio :label="false" :disabled="scope.row.scoring"
                    >不通过</el-radio
                  >
                </el-radio-group>
              </template>
            </el-table-column>
          </el-table>
          <div class="table-box" :style="'height: ' + windowHeight + 'px;'">
            <table class="table-body">
              <tr class="tr-head">
                <td width="80px" align="center">序号</td>
                <td>班级</td>
                <td class="">学号</td>
                <td class="">学生</td>
                <td width="160px">附件（点击浏览）</td>
                <td width="200px">审核</td>
              </tr>
              <tr
                class="tr-body"
                v-for="(item, index) in itemData"
                :key="index"
              >
                <td align="center">{{ index + 1 }}</td>
                <td>{{ item.className }}</td>
                <td>{{ regNull(item.studentNo) ? "/" : item.studentNo }}</td>
                <td>
                  {{ regNull(item.studentName) ? "/" : item.studentName }}
                </td>
                <td>
                  <el-image
                    fit="contain"
                    :key="index"
                    style="width: 50px; height: 50px; marginleft: 10px"
                    :src="item.uploadFild[0]"
                    :preview-src-list="item.uploadFild"
                  >
                  </el-image>
                </td>
                <td width="130px">
                  <div class="td-system">
                    <div
                      class="td-btn-box btn-yes"
                      @click="handleAuditStatus(item, true)"
                    >
                      通过
                    </div>
                    <div
                      class="td-btn-box btn-no"
                      @click="handleAuditStatus(item, false)"
                    >
                      不通过
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <!-- <comPage :paging="paging" @pagingClick="pagingClick" v-if="false">
        </comPage> -->
      </div>
      <div class="card-body" v-else>
        <el-empty :image-size="200" description="暂无数据" name="3"></el-empty>
      </div>
    </el-card>
    <div class="row" style="margin-top: 10px">
      <div class="col-6">
        <el-button icon="el-icon-back" @click="onBack()">返回</el-button>
        <el-button
          v-if="false"
          slot="reference"
          type="primary"
          icon="el-icon-circle-check"
          @click="onSave()"
          >提交
        </el-button>
      </div>
      <div class="col-6 text-right" v-if="false">
        <el-button @click="onCheckAll">
          <svg class="icon" aria-hidden="true" v-if="iconAllCheck">
            <use xlink:href="#fax-circle-check"></use>
          </svg>
          <svg class="icon" aria-hidden="true" v-else>
            <use xlink:href="#fax-circle-o"></use>
          </svg>
          全部通过
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/Admin.css";
// import comPage from "@/components/Page.vue";
import comImport from "@/components/Import.vue";
import search from "@/components/search.vue";
import operationBtn from "@/components/operationBtn.vue";
export default {
  components: {
    // comPage,
    comImport,
    search,
    operationBtn,
  },
  data() {
    return {
      // 用于全选状态
      iconAllCheck: false,
      itemData: [],
      dialogTitle: "",
      dialogVisible: false,
      SearchTitles: [],
      SearchList: null, //搜索集合
      id: null,
      fullscreenLoading: false,
      Title: null,
      ImportTitle: null,
      ImportUrl: null,
      ImportFile: null,
      windowHeight: 0,

      // paging: {
      //   //分页数据
      //   totalCount: 0, // 总共页数
      //   pageSize: 10, // 当前请求数量
      //   currentPage: 1, //当前在第几页
      // },
    };
  },
  created() {
    let that = this;
    that.id = that.$route.params.Id;
    that.Title = "活动附件审核";
    if (that.id != null && typeof that.id != "undefined" && that.id != "") {
      Init(that);
    }
  },
  mounted() {
    let that = this;
    that.windowHeight = window.innerHeight - 300;
  },
  methods: {
    handleAuditStatus(val, falg) {
      let that = this;
      let msg = falg ? "确定要审核通过吗?" : "您确定要拒绝该审核吗?";
      confirm(that, msg, function (res) {
        if (res) {
          let url =
            "/api/admin/activity/attachaudit/" +
            val.rosterId +
            "?auditResult=" +
            falg;
          that.fullscreenLoading = true;
          ajaxPut(that, url, null, function (r) {
            that.fullscreenLoading = false;
            pagingPage(that);
          });
        }
      });
    },
    onCheckAll(val) {
      this.iconAllCheck = !this.iconAllCheck;
      if (this.iconAllCheck) {
      }
    },
    onImportSuccess(param) {
      let that = this;
      Init(that);
    },
    onSave() {},
    onBack() {
      let that = this;
      back(that);
    },
    onSearch(params) {},
    // pagingClick(type, val) {
    //   if (type == 1) {
    //   } else {
    //   }
    // },
  },
  watch: {
    $route() {
      let that = this;
      Init(that);
    },
  },
};

function Init(that) {
  pagingPage(that);
}

function pagingPage(that) {
  that.fullscreenLoading = true;
  ajaxGet(that, `/api/admin/activity/roster/${that.id}`, null, function (res) {
    that.fullscreenLoading = false;
    that.itemData = res
      .filter((item) => item.attachment && item.attachAudit == null)
      .map((it) => {
        it.uploadFild = it.attachment
          .split("|")
          .map((cur) => `${that.$ServerUrl()}${cur}?v=${Math.random()}`);
        it.isAudit = false;
        return it;
      });
    // that.paging.totalCount = that.itemData.length;
  });
}
</script>

<style scoped="scoped" lang="less">
.table-box {
  overflow-y: auto;
}
.table-body {
  border-top: 1px solid #ebeef5;
  width: 100%;
  tr {
    border-bottom: 1px solid #ebeef5;
    &:hover {
      background-color: #f4f6f9;
    }
    &:nth-child(even) {
      background-color: #fafafa;
    }
  }
  .tr-head {
    td {
      padding: 12px 10px;
      color: #909399;
      font-weight: 500;
      font-size: 14px;
    }
  }
  .tr-body {
    td {
      padding: 12px 10px;
      font-weight: 400;
      font-size: 14px;
      color: #606266;
    }
  }

  .td-system {
    display: flex;
    .td-btn-box {
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      border: 1px solid #dcdfe6;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: none;
      margin: 0;
      transition: 0.1s;
      font-weight: 500;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      padding: 6px 10px;
      font-size: 14px;
      border-radius: 4px;
    }
    .btn-yes {
      color: #fff;
      background-color: #67c23a;
      border-color: #67c23a;
    }
    .btn-no {
      color: #fff;
      background-color: #f56c6c;
      border-color: #f56c6c;
      margin-left: 10px;
    }
  }
}

/deep/ .el-table th > .cell {
  text-align: center;
}
</style>
